var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27352",
    "data-name": "Path 27352",
    d: "M5.672,289.856.529,295l5.143,5.143v-4.286h12a5.143,5.143,0,1,1,0,10.286H12.529v1.714h5.143a6.857,6.857,0,1,0,0-13.714h-12Z",
    transform: "translate(-0.529 -289.856)",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledUndo);
export default __webpack_public_path__ + "static/media/DisabledUndo.42da05d9624248d81805861295cfedc9.svg";
export { ForwardRef as ReactComponent };